<div *ngIf="loading" class="fullScreenLoading"></div>
<p-toast />
<div style="display: flex;
padding-top: 5rem;
justify-content: center;
flex-direction: column;
align-items: center;">
    <!-- validate your email
    userId: e74c8af1-5326-427b-8c5a-7ab60cd2c670 -->
    <div style="max-width: 90vw;
    width: 35rem;">
        <p-card>
            <div class="logo-container">
                <div class="logo">
                    <img [src]="logo" alt="IMADATA" style="width: 100%; height: auto; border-radius: 0.5rem;">
                </div>
            </div>
            <div *ngIf="!validacion_completa"
            style="display: flex; justify-content: center;  flex-direction: column; margin-top: 2rem;text-align: center; padding: 0rem 2rem;">
                <p style="
                font-size: 2rem;
                font-weight: 700;">¡Verifica tu correo!</p>
                <p>Antes de iniciar sesión por primera vez, es necesario que confirmes tu correo electrónico y guardes tu contraseña escribiendola en los dos espacios de abajo, posteriormente da click en el botón de "Validar correo electrónico".
                </p>
                <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
                    <div class="password-container">
                        <p>Contraseña</p>
                        <p-password id="pass1" formControlName="pass1" [feedback]="true" [toggleMask]="true"/>
                        <div *ngIf="formGroup.get('pass1').hasError('required') && formGroup.get('pass1').touched">
                            La contraseña es obligatoria
                        </div>
                    </div>
                    <div class="password-container">
                        <p>Repita la contraseña</p>
                        <p-password id="pass2" formControlName="pass2" [feedback]="true" [toggleMask]="true"/>
                        <div *ngIf="formGroup.get('pass2').hasError('required') && formGroup.get('pass2').touched">
                            La contraseña es obligatoria
                        </div>
                    </div>
                    <div *ngIf="formGroup.hasError('passwordMismatch') && formGroup.get('pass2').touched">
                        Las contraseñas no coinciden
                    </div>
                    <button type="submit" pButton pRipple class="p-button-success" [label]="'Validar correo electrónico'" 
                        [disabled]="!user_allowed"></button>
                  </form>
                <p style="font-size: 0.9rem; margin-top: 3rem;">Si tienes algún problema, no dudes en contactar con nuestro equipo.</p>
                
            </div>
            <div *ngIf="validacion_completa">
                <div style="display: flex; justify-content: center;  flex-direction: column; margin-top: 2rem;text-align: center; padding: 0rem 2rem; gap: 2rem">
                    <p style="
                    font-size: 2rem;
                    font-weight: 700;">¡Correo verificado!</p>
                    <p>¡Tu correo ha sido verificado exitosamente! Ahora puedes iniciar sesión con tu correo y contraseña.</p>
                    <button pButton pRipple class="p-button-success" [label]="'Iniciar sesión'" [routerLink]="['/login']"></button>
                </div>
            </div>
        </p-card>
    </div>
    
</div>